export default __webpack_public_path__ + "static/media/home-simple.0c2a4b32.png";